import { useSuspenseQuery } from '@tanstack/react-query';

import { getRequest } from '@/api/rest/hooks/requests/get';
import {
  GET_DASHBOARD_ORGANIZATION_PRODUCT_PATH,
  GetDashboardOrganizationProductErrorDto,
  GetDashboardOrganizationProductRequestQueryParams,
  GetDashboardOrganizationProductSuccessDto,
} from '@/api/rest/resources/types/dashboard';
import { useOrganizationId } from '@/pages/shared/hooks/useOrganizationId';
import { assertIsDefined } from '@/utils/assert';

type SuccessDto = GetDashboardOrganizationProductSuccessDto;
type ErrorDto = GetDashboardOrganizationProductErrorDto;

export const useOrganizationProducts = (organizationIdArg?: string, purchased?: boolean) => {
  const orgId = useOrganizationId();
  const organizationId = organizationIdArg ?? orgId;
  assertIsDefined(organizationId, 'organizationId');

  const queryParams: GetDashboardOrganizationProductRequestQueryParams = { organization_id: organizationId, purchased };

  const queryFn = async () => {
    return getRequest<SuccessDto>(GET_DASHBOARD_ORGANIZATION_PRODUCT_PATH, undefined, queryParams);
  };

  return useSuspenseQuery<SuccessDto, ErrorDto>({
    queryKey: ['dashboard', 'organization', 'organization-products', queryParams],
    queryFn,
    staleTime: 1000 * 60 * 5,
  });
};
